import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { zoomFactorValue } from '../Solution/Preview.types';
import { ZoomInput } from '../Solution/Toolbar.styles';
import TooltipOne from '../TooltipOne/TooltipOne.component';
import { useLayoutContext } from '../../Context/Layout.context';

interface DropdownZoomProps {
  zoomFactor: number | unknown;
  zoomValues: number[];
  handleZoomChange: (event: React.ChangeEvent<{ name?: string; value: unknown }>) => void;
}

const DropdownMenuZoom: React.FC<DropdownZoomProps> = (props) => {
  const { isAnyDropdownOpen } = useLayoutContext();

  return (
    <TooltipOne title={'Ustaw powięszenie strony'} placement="top">
      <FormControl>
        <Select
          id="pagesSize"
          value={props.zoomFactor}
          onChange={props.handleZoomChange}
          onOpen={() => (isAnyDropdownOpen.current = true)}
          onClose={() => (isAnyDropdownOpen.current = false)}
          input={<ZoomInput />}
        >
          {props.zoomValues.map(
            (value: number) =>
              value !== zoomFactorValue.screenWidth && (
                <MenuItem disableRipple key={value} value={value}>
                  {value * 100}%
                </MenuItem>
              ),
          )}
          <hr></hr>
          <MenuItem disableRipple value={zoomFactorValue.screenWidth}>
            Dostosuj do szerokości ekranu
          </MenuItem>
          <MenuItem disableRipple value={zoomFactorValue.screenWidthAndHeight}>
            Dostosuj do rozmiaru okna
          </MenuItem>
        </Select>
      </FormControl>
    </TooltipOne>
  );
};

export default DropdownMenuZoom;
